module.exports = "//cdn.mxpnl.com/static/asset-cache/47325775cb50e3e23919aa6739146341/iron/common/components/spinner/horse-run.gif";